module.exports = {"name":"guidedSteps","audiences":["allMembers"],"autoTrack":true,"experimentAllocation":0.1,"defaultWeight":1,"bucketVersion":"v2","experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/guidedSteps.json
// module id = 21Cu
// module chunks = 0